import React from 'react';

interface Props {
    value: string;
}

export const Months: React.FC<Props> = ({ value }: Props) => <>{`${value} maanden`}</>;
